module.exports = __webpack_public_path__ + "img/imagen2.e95d3588.png";